import { getLocales } from 'assets/locales/Locale';
import { ProgressInfo } from 'assets/utils/data/Iterations';
import { replaceStringTemplateWithValues } from 'assets/utils/data/String';
import './ProgressWindow.scss';

export type ProgressKey =
  | 'priceDistribution'
  | 'distributorPriceDistribution'
  | 'dealerLimit'
  | 'dealerDiscount'
  | 'syncAllWithVertafore'
  | 'resendForSigning'
  | 'reuploadAllSignedDocuments'
  | 'importMissingSigningCertificates'
  | 'importSignedDocumentationAggregates'
  | 'download';
const PROGRESS_WINDOW_DOM_ID = 'progressWindow';

function getProgressTitleByKey(progressKey: ProgressKey) {
  const { lang } = getLocales();

  return progressKey === 'download'
    ? lang.download
    : progressKey === 'resendForSigning'
      ? lang.resendForSigning
      : progressKey === 'reuploadAllSignedDocuments'
        ? lang.reuploadSignedDocuments
        : progressKey === 'importMissingSigningCertificates'
          ? lang.importMissingSigningCertificates
          : progressKey === 'importSignedDocumentationAggregates'
            ? lang.importSignedDocumentationAggregates
            : progressKey === 'syncAllWithVertafore'
              ? lang.syncing
              : progressKey === 'priceDistribution'
                ? lang.prices
                : progressKey === 'distributorPriceDistribution'
                  ? lang.distributorDistributions
                  : progressKey === 'dealerLimit'
                    ? lang.limits
                    : lang.adjustments;
}

export default function ProgressWindow() {
  return <div id={PROGRESS_WINDOW_DOM_ID} className="ProgressWindow" />;
}

export function addProgressToWindow(progressKey: ProgressKey, progressInfo: ProgressInfo) {
  const progressWindow = document.getElementById(PROGRESS_WINDOW_DOM_ID);
  if (progressWindow) {
    let progressSection = progressWindow.querySelector(`#${progressKey}`);
    if (!progressSection) {
      progressSection = document.createElement('div');
      progressSection.id = progressKey;
      progressWindow.appendChild(progressSection);
    }
    progressSection.setAttribute('progress', progressInfo.percentCompleted.toFixed(2));
    progressSection.innerHTML = replaceStringTemplateWithValues(getLocales().lang.progressWindowStatus, {
      title: getProgressTitleByKey(progressKey),
      currentItem: String(progressInfo.currentItem),
      totalItems: String(progressInfo.totalItems),
      percentCompleted: progressInfo.percentCompleted.toFixed(2),
      estimatedSeconds: (progressInfo.timeEstimateMs / 1000).toFixed(0),
    });

    if (
      Array.from(progressWindow.getElementsByTagName('*')).every(
        (it) => it.getAttribute('progress')?.toString() === '100.00'
      )
    ) {
      progressWindow.innerHTML = '';
    }
  }
}
